export const SN_CART = 'cart'
export const CART_OPEN_EDIT_MODE = SN_CART + '/CART_OPEN_EDIT_MODE'
export const CART_EDIT_MODE_SET_FILTERS = SN_CART + '/CART_EDIT_MODE_SET_FILTERS'
export const CART_EDIT_QTY = SN_CART + '/CART_EDIT_QTY'
export const CART_CLOSE_EDIT_MODE = SN_CART + '/CART_CLOSE_EDIT_MODE'
